<template>
  <div class="scenario-container">
    <div class="m-s-right-btn">
      <div class="m-s-zoom">
        <div class="zoom-add" @click.prevent.stop="zoomInViaNavigation">
          <PlusOutlined />
        </div>
        <div class="zoom-minus" @click.prevent.stop="zoomOutViaNavigation">
          <MinusOutlined />
        </div>
      </div>
      <a-popover overlayClassName="css-1dowtov" placement="leftBottom" trigger="hover">
        <div class="m-s-map-icon">
          <div class="select-btn">
            <img :src="mapIcon" />
          </div>
        </div>
        <template #title>{{ '' }}</template>
        <template #content>
          <div class="map-imglayer-data">
            <div class="m-i-d-title"> 地图实验室 </div>
            <div class="select-imglayer">

              <div class="img-w" :class="{ active: currentLayer === 0 }"
                @click.stop="handleSettingLayer(0, showImgLayer.includes('img_w_label'))">
                <div class="img-w-mark">
                  <a-checkbox-group v-model:value="showImgLayer" @change="(val: string[]) => handleChangeImgLayer(val, 0)">
                    <a-checkbox v-for="(dict, index) in layerOptions" :key="dict" :value="dict"
                      v-show="index === 0"></a-checkbox>
                  </a-checkbox-group>
                  <span> 开启路网 </span>
                </div>
                <div class="img-w-name">
                  <span>天地图</span>
                </div>
              </div>
              <div class="img-w" :class="{ active: currentLayer === 1 }"
                @click.stop="handleSettingLayer(1, showImgLayer.includes('a_map_img_w_label'))">
                <div class="img-w-mark">
                  <a-checkbox-group v-model:value="showImgLayer" @change="(val: string[]) => handleChangeImgLayer(val, 1)">
                    <a-checkbox v-for="(dict, index) in layerOptions" :key="dict" :value="dict"
                      v-show="index === 1"></a-checkbox>
                  </a-checkbox-group>
                  <span> 开启路网 </span>
                </div>
                <div class="img-w-name">
                  <span>高德地图</span>
                </div>
              </div>
              <!-- <div class="img-w" :class="{ active: currentLayer === 2 }" @click.stop="handleSettingLayer(2, showImgLayer.includes('baidu_img_w_label'))">
                  <div class="img-w-mark">
                    <a-checkbox-group v-model:value="showImgLayer"
                       @change="(val)=>handleChangeImgLayer(val,2)">
                      <a-checkbox v-for="(dict,index) in layerOptions" :key="dict" :value="dict" v-show="index === 2"></a-checkbox>
                      </a-checkbox-group>
                    <span> 开启路网 </span>
                  </div>
                  <div class="img-w-name">
                    <span>百度地图</span>
                  </div>
                </div> -->
            </div>
          </div>
        </template>
      </a-popover>
    </div>
    <div id="scenario-map" ref="scenarioContainer" class="scenario-map"></div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, nextTick, onBeforeUnmount } from 'vue'
import mapIcon from '/@/assets/images/map-icon.png'
import { initScenarioMap, viewMap, viewState, currentLayer, showImgLayer, layerOptions, handleSettingLayer } from '../hooks/Cesium/use-scenario-map'
import { useMyStore } from '../store'

const scenarioContainer = ref(null)
const store = useMyStore()

function handleChangeImgLayer (val: string[], number: number) {
  nextTick(() => {
    handleSettingLayer(number, val.includes(layerOptions[number]))
  })
}
function zoomInViaNavigation () {
  viewState.drawTool?.zoomInViaNavigation()
}
function zoomOutViaNavigation () {
  viewState.drawTool?.zoomOutViaNavigation()
}
onMounted(() => {
  initScenarioMap(scenarioContainer.value, store)
})

onBeforeUnmount(() => {
  viewState.drawTool?.destroy()
  viewMap?.destroy()
})
</script>

<style scoped lang="scss">
.scenario-container {
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;

  .m-s-right-btn {
    position: absolute;
    right: 20px;
    bottom: 50px;
    z-index: 400;

    .m-s-icon {
      width: 28px;
      height: 28px;
      margin: 10px auto;
      border-radius: 2px;
      text-align: center;
      line-height: 30px;
      cursor: pointer;
      position: relative;
      background-color: #1f1f1f;
      color: rgba(255, 255, 255, 0.85);

      &:hover {
        color: #1088f2;
      }
    }

    .m-s-zoom {
      width: 28px;
      margin: 10px auto;
      text-align: center;
      line-height: 28px;
      box-shadow: 0 0 4px #0009;
      cursor: pointer;

      .zoom-add {
        width: 28px;
        height: 28px;
        border-radius: 2px 2px 0 0;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }

      .zoom-minus {
        width: 28px;
        height: 28px;
        border-radius: 0 0 2px 2px;
        background-color: #1f1f1f;
        color: rgba(255, 255, 255, 0.85);

        &:hover {
          color: #1088f2;
        }
      }
    }

    .m-s-map-icon {
      width: 40px;
      height: 40px;
      background: #fff;
      border-radius: 50%;
      margin: 10px auto;
      padding: 3px 0 0;
      cursor: pointer;

      .select-btn {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        margin: 0 auto;
        -webkit-user-select: none;
        user-select: none;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%
        }
      }
    }
  }

  .scenario-map {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 300;
  }
}
.map-imglayer-data {
      width: 240px;
      height: 100px;
      position: relative;

      .m-i-d-title {
        font-weight: 600;
        margin: 0 0 6px;
        font-size: 14px;
      }

      .m-i-d-switch {
        display: flex;
        font-size: 14px;
        margin: 0 0 6px;

        .txt {
          line-height: 22px;
          margin: 0 0 0 4px;
        }
      }

      .switch-right {
        margin-left: 50px;
      }

      .select-imglayer {
        width: 100%;
        height: 100px;
        display: flex;
        // justify-content: space-around;

        .vec-w,
        .img-w {
          width: 120px;
          height: 80px;
          background-size: 100% 100%;
          position: relative;
          border: 2px solid #fff;

          &.active,
          &:hover {
            border: 2px solid #2d8cf0;

            .vec-w-name span,
            .img-w-name span {
              background-color: #2d8cf0;
            }
          }
        }

        .vec-w {
          background-image: url('/@/assets/images/map-icon2.png');
        }

        .img-w {
          background-image: url('/@/assets/images/map-icon.png');

          .img-w-mark {
            height: 24px;
            padding: 0 4px;
            background: #00000080;
            display: flex;
            color: #fff;

            .ant-checkbox-group {
              width: 30px;
            }

            .ant-checkbox-wrapper {
              color: #fff;
            }

            .txt {
              line-height: 22px;
              margin: 0 0 0 4px;
            }
          }
        }

        .vec-w-name,
        .img-w-name {
          position: absolute;
          right: 0;
          bottom: 0;
          line-height: 22px;
          color: #fff;
          width: 100%;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0.5), transparent 0, rgba(0, 0, 0, 0.4));
          text-align: right;

          span {
            padding: 0 4px;
          }
        }
      }
    }
</style>
